import { useMutation } from '@tanstack/react-query';

import { enrol } from '../api';

export const useEnrol = () => {
  return useMutation({
    mutationFn: enrol,
  });
};
